import { Component, input, output } from '@angular/core';
import { PairChallenge } from '@era/locations-sdk';

@Component({
  selector: 'era-pairing-challenge-ui',
  templateUrl: './pairing-challenge.component.html',
})
export class PairingChallengeComponent {
  public readonly challenge = input.required<PairChallenge>();
  readonly enroll = output<PairChallenge>();

  public continue() {
    this.enroll.emit(this.challenge());
  }
}
